export const config = {
  initialColorMode: "light",
  useSystemColorMode: false,
};
